import {
  GET_PRODUCTS,
  GET_PRODUCT,
  GET_PRODUCTS_WITH_IDS,
  GET_MASTER_TAGS,
  GET_MASTER_TAGS_WITH_IDS,
  GET_PRODUCT_GROUPS_FOR_PRODUCT
} from "../constants/action-types";

import Axios from "axios";

import { getApiCodes, getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

export const IncludeType = Object.freeze({"Include" : 0, "Exclude" : 1 })

/* 
  Get products.
*/
export const getProducts = callback => dispatch => {
  const productMap = {};
  adalApiFetch(Axios, `${API_CONFIG.URL}/products`, {
    method: "get"
  }).then(res => {
    const products = res.data;

    products.forEach((product) => { 
      productMap[product.id] = product;
    })

    dispatch({
      type: GET_PRODUCTS,
      payload: productMap
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
};

/* 
  Get Product
*/
export const getProduct = (productId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/products/${productId}`, {
    method: "get"
  }).then(res => {
    const product = res.data;

    dispatch({
      type: GET_PRODUCT,
      payload: product.id
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

/* 
  Get Products for ids
*/
export const getProductsForIds = (productIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/products?forIds=true`, {
    method: "post",
    data: productIds
  }).then(res => {
    
    dispatch({
      type: GET_PRODUCTS_WITH_IDS,
      payload: res.data.products
    });
      
    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

/* 
  Get Product Included in Product Groups
*/
export const getProductGroupsForProduct = (productId, inclusiveType, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/products/${productId}/productGroups?inclusiveType=${inclusiveType}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_PRODUCT_GROUPS_FOR_PRODUCT,
      payload: { data : res.data.productGroupsForProduct, inclusiveType }
    });
      
    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

/* 
  Get master tags.
*/
export const getMasterTags = callback => dispatch => {
  const productMap = {};
  adalApiFetch(Axios, `${API_CONFIG.URL}/masterTags`, {
    method: "get"
  }).then(res => {
    const data = res.data;

    dispatch({
      type: GET_MASTER_TAGS,
      payload: data.masterTagsForProducts
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
};